module.exports = __webpack_public_path__ + "static/img/battery.9b9eeae3.png";